import { AnalyseImportProjectFromStorageBackupRequest } from '../../../entities/AnalyseImportProjectFromStorageBackupRequest';
import { ImportProjectFromStorageBackup } from '../../../entities/ImportProjectFromStorageBackup';
import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'SolutionExplorer', controller: 'SolutionExplorer') => ({
	CreateItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateItem'
	}),
	CreateAssetItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateAssetItem'
	}),
	DeleteItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteItem'
	}),
	GetItemContent: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetItemContent'
	}),
	HasItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'HasItem'
	}),
	RenameItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'RenameItem'
	}),
	UpdateItemContent: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateItemContent'
	}),
	GetNavigationItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetNavigationItems'
	}),
	OpenNavigationItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'OpenNavigationItem'
	}),
	CreateProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateProject'
	}),
	GetRecentItems: new PostMethod<any[], null>({
		service,
		controller,
		method: 'GetRecentItems'
	}),
	UpdateRecentItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateRecentItem'
	}),
	DeleteRecentItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteRecentItem'
	}),
	CreateSolution: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateSolution'
	}),
	AddNewProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'AddNewProject'
	}),
	RemoveProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'RemoveProject'
	}),
	AddExistingProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'AddExistingProject'
	}),
	UpdateProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateProject'
	}),
	CreateArchiveForm: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateArchiveForm'
	}),
	ExportProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'ExportProject'
	}),
	ImportProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'ImportProject'
	}),
	ValidateProjects: new PostMethod<any, any>({
		service,
		controller,
		method: 'ValidateProjects'
	}),
	CreateActionForm: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateActionForm'
	}),
	ControlProjectFromDMBackup: new PostMethod<any, any>({
		service,
		controller,
		method: 'ControlProjectFromDMBackup'
	}),
	ControlProjectFromLocalBackup: new PostMethod<any, any>({
		service,
		controller,
		method: 'ControlProjectFromLocalBackup'
	}),
	AnalyseImportProjectFromDMBackup: new PostMethod<any, any>({
		service,
		controller,
		method: 'AnalyseImportProjectFromDMBackup'
	}),
	AnalyseImportProjectFromLocalBackup: new PostMethod<any, any>({
		service,
		controller,
		method: 'AnalyseImportProjectFromLocalBackup'
	}),
	AnalyseImportProjectFromStorageBackup: new PostMethod<
		any,
		AnalyseImportProjectFromStorageBackupRequest
	>({
		service,
		controller,
		method: 'AnalyseImportProjectFromStorageBackup'
	}),
	ImportProjectFromLocalBackup: new PostMethod<any, any>({
		service,
		controller,
		method: 'ImportProjectFromLocalBackup'
	}),
	ImportProjectFromDMBackup: new PostMethod<any, any>({
		service,
		controller,
		method: 'ImportProjectFromDMBackup'
	}),
	ImportProjectFromStorageBackup: new PostMethod<any, ImportProjectFromStorageBackup>({
		service,
		controller,
		method: 'ImportProjectFromStorageBackup'
	})
});

export { getMethods };
